<template>
  <div class="animated fadeIn">
    <div id="inventorycategories">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i>
          Inventory Categories
          <records-count :total="pageInfo.totalItems" />
          <b-button
            @click="add()"
            size="sm"
            title="Add"
            style="float: right;margin-bottom: 5px;">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </b-button>
        </div>
        <div class="card-body">
          <!-- <pre>{{ pageInfo | json }}</pre> -->
          <grid-component
            isResizable
            isReorderable
            isSortable
            :gridId="gridId"
            :pageable="pageable"
            :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
            :take="pageInfo.pageSize"
            :itemData="itemData"
            :pageSizes="pageInfo.pageSize"
            :totalItems="pageInfo.totalItems"
            :fields="fields"
            :sortBy="pageInfo.sortBy"
            :sortOrder="pageInfo.sortOrder"
            :sortMethod="sortGrid"
            :onEdit="edit"
            :styleCustom="'height: 335px'"
            @getData="onGetData"
            :isTblLoader="tblLoader"
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import gridFields from './fields';
import GridComponent from '@/shared/components/GridComponent';
const SEARCH_DEBOUNCE_TIME = 750;
import { GRID_ID,GRID_PAGE_SIZES } from '@/shared/constants';

export default {
  components: {
    GridComponent
  },
  data() {
    return {
      fields: gridFields,
      gridId: GRID_ID.INVENTORY_CATEGORY_GRID,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
    };
  },
  computed: {
    ...mapGetters('inventorycategories', [
      'gridList',
      'pageInfo',
      'tblLoader',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      if (this.gridList == undefined || !this.gridList.length) return [];
      return this.gridList;
    },
  },
  methods: {
    ...mapActions('inventorycategories', [
      'getAll',
      'sortGrid',
      'remove',
    ]),
    ...mapMutations('inventorycategories',['setItem']),
    async onGetData(params) {
			await this.getAll(params);
		},
    onRowClick: function(event){
      this.edit(event.dataItem);
    },
    edit(item) {
      this.$router.push({ name: 'inventorycategoryEdit', params: { id: item.id } });
    },
    add() {
      this.$router.push({ name: 'inventorycategoryAdd' });
    },
    getNestedValue: function(field, dataItem) {
      console.log(field, dataItem)
    },
  },
  async mounted() {
    this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
    await this.getAll({});
  },
};
</script>
<style>
.b-pagination {
  justify-content: center;
}

#KendoGrid .k-virtual-scrollable-wrap table
{
    min-width: 800px;
}
</style>
